/* -- mui-- */
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  main: {
    marginTop: theme.spacing(6) + 2, // --> 50px
  },
}));
